import axios from 'axios';
import SiteHeader from '@shared/SiteHeader';
import BlogDetails from '@local/blogs/BlogDetails';
import Share from '@shared/Share';
import RelatedPosts from '@local/blogs/RelatedPosts';
import { getStrapiURL } from '@lib/api';

const apiBaseUrl = getStrapiURL();

const BlogDetail = ({ blogData, relatedBlogs }) => {
  return (
    <>
      <SiteHeader
        title={blogData.title}
        desc={blogData.description}
        url={`/blogs/${blogData.slug}`}
        image={blogData?.image?.data?.attributes?.url}
      />
      <div className="container-default-1209px">
        <div className="w-auto py-8 sm:px-0 lg:mx-12 lg:px-8">
          <div className="hidden lg:block">
            <div className="-mr-10 lg:sticky lg:top-[120px] lg:float-right">
              <Share slug={`/blogs/${blogData.slug}`} />
            </div>
            <BlogDetails blogData={blogData} relatedBlogs={relatedBlogs} />
          </div>
          <div className="block lg:hidden">
            <BlogDetails blogData={blogData} relatedBlogs={relatedBlogs} />
          </div>
          <RelatedPosts blogData={blogData} relatedBlogs={relatedBlogs} />
        </div>
      </div>
    </>
  );
};

export default BlogDetail;

export async function getStaticProps({ params }) {
  const { blogSlug } = params;
  try {
    const { data } = await axios.get(
      `${apiBaseUrl}/api/articles?filters[slug][$eq]=${blogSlug}&populate=image&populate=author.picture&populate=category`
    );
    const blogData = data?.data[0]?.attributes;

    if (!blogData) {
      return {
        notFound: true,
      };
    }

    const relatedBlogs = await axios.get(
      `${apiBaseUrl}/api/articles?filters[slug][$ne]=${blogSlug}&populate=category&populate=author&populate=image&pagination[page]=0&pagination[pageSize]=5`
    );

    return {
      props: { blogData, relatedBlogs: relatedBlogs.data.data || [] },
      revalidate: 3600,
    };
  } catch (error) {
    console.log(error);
    return {
      notFound: true,
    };
  }
}

export async function getStaticPaths() {
  // on-demand if the path doesn't exist.
  return { paths: [], fallback: 'blocking' };
}
